import { dispatch, redirect, NOT_FOUND } from '@rematch/core'

// Using dispatch from '@rematch/core' instead of 'react-redux'
// because it has namespace access to 'success()' and 'error()' for each apiFactory model.

const replaceUrlParams = (url, payload, query) => {
  // Works the same as React Router urls - '/posts/:id' becomes '/posts/123'
  // Uses the template url in model request, and the payload object - {id: 123}
  var newUrl = url
  for (var item in payload) {
    if (item !== 'body' && payload.hasOwnProperty(item)) {
      newUrl = newUrl.replace(`:${item}`, `${payload[item]}`)
    }
  }
  return `${newUrl}${query ? '?' + query : ''}`
  // return newUrl
}

const apiMiddleware = (store) => (next) => (action) => {
  next(action);

  // Check if this is an API request.
  if (action.request && action.request.url) {
    const { name, request, payload } = action;

    // Setup Request
    const setup = {
      method: request.method || 'get',
      headers: request.headers,
      body: payload.body ? JSON.stringify(payload.body) : undefined,
    }

    // Parse the URL for any params - e.g: ':id' or ':name'
    const { location } = store.getState()
    const query = payload.search || location.search
    const url = payload.url || replaceUrlParams(request.url, payload, query)
    // const url = replaceUrlParams(request.url, payload)
    // console.log(url,setup);

    // Request started - dispatch to redux - set loading state
    dispatch[name].pending()

    // Multipage request
    var totalPages = 0;
    var allResults = [];
    const multipageRequest = (results) => {
      allResults = results;
      //console.log('Got results from server', results.length); 
      for (let i = 2; i <= totalPages; i++) {
        const next_url = url + "&page=" + i
        fetch(next_url)
          .then(response => { return response.json() })
          .then(moreresults => {
            console.log('fetch',next_url)
            allResults = allResults.concat(moreresults);
          });
      }
      dispatch[name].success(allResults)
    }

    // Do API request
    fetch(url, setup)
      .then( response => {
        totalPages = response.headers.get('X-WP-TotalPages');
        console.log('total pages:', totalPages)
        return response.json()
      })
      .then( data => {
        // Request successful - dispatch data to redux - set data, remove loading state
        // dispatch({type: 'LOG', payload: data })
        if (data.length) {
          if (totalPages > 0) {
            multipageRequest(data)
          } else {
            dispatch[name].success(data)
          }
        } else {
          dispatch[name].error({message: `${name} not found`})
          if (action.redirect) dispatch(redirect({ type: NOT_FOUND }))
        }
      })
      .catch( error => {
        // Request error - dispatch error to redux - set error, remove loading state
        // dispatch({type: 'LOG', payload: error })
        dispatch[name].error(error)
        if (action.redirect) dispatch(redirect({ type: NOT_FOUND }))
      })
  }
};

export default apiMiddleware



// WEBPACK FOOTER //
// ./src/redux/plugins/api/api.middleware.js